import React from "react";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import Button from '@mui/material/Button';
import { useLanguage } from "../../LanguageContext";

export default function ExportPDF() {
  const { language } = useLanguage();
  const exportPDF = () => {
    const pdf = new jsPDF("p", "mm", "a4");

    // Target the Friday table and Saturday table
    const fridayTable = document.getElementById("fridayTable");
    const saturdayTable = document.getElementById("saturdayTable");

    if (fridayTable && saturdayTable) {
      // Add Friday title and table
      pdf.setFontSize(16);
      pdf.setFont("helvetica", "bold");
      pdf.text("9 May 2025 - Friday", 10, 15);

      html2canvas(fridayTable).then((canvas) => {
        const imgData = canvas.toDataURL("image/png");
        const imgProps = pdf.getImageProperties(imgData);
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

        pdf.addImage(imgData, "PNG", 10, 20, pdfWidth - 20, pdfHeight);

        // Add new page for Saturday
        pdf.addPage();
        pdf.setFontSize(16);
        pdf.text("10 May 2025 - Saturday", 10, 15);

        html2canvas(saturdayTable).then((canvas) => {
          const imgData2 = canvas.toDataURL("image/png");
          const imgProps2 = pdf.getImageProperties(imgData2);
          const pdfHeight2 = (imgProps2.height * pdfWidth) / imgProps2.width;

          pdf.addImage(imgData2, "PNG", 10, 20, pdfWidth - 20, pdfHeight2);

          // Save the PDF
          pdf.save("ProgramSchedule.pdf");
        });
      });
    }
  }

  return (
    <div style={{ textAlign: "center", margin: "20px" }}>
      <Button
          variant="contained"
          onClick={exportPDF}
          style={{ padding: "10px 20px", fontSize: "16px" }}
          sx={{
            backgroundColor: "#cc0000",
            color: "#ffffff",
            "&:hover": { backgroundColor: "#a20000" },
            fontWeight: "bold",
            textTransform: "uppercase",
          }}>
          {language === "en" ? "Program PDF" : "Program PDF"}
        </Button>
    </div>
  )
}